import { useState } from "react";

export default function BeforeAfter({ before, after, labelBefore = "Vorher", labelAfter = "Nachher" }) {
    const [pos, setPos] = useState(50);
    return (
        <div className="ba-slider aspect-[4/3] rounded-sm">
            <img src={before} alt={labelBefore} />
            <div className="after-wrap" style={{ clipPath: `inset(0 0 0 ${pos}%)` }}>
                <img src={after} alt={labelAfter} />
            </div>
            <span className="absolute top-4 left-4 bg-ink/80 text-paper text-[10px] tracking-[0.2em] uppercase px-3 py-1 font-semibold">
                {labelBefore}
            </span>
            <span className="absolute top-4 right-4 bg-brand text-paper text-[10px] tracking-[0.2em] uppercase px-3 py-1 font-semibold">
                {labelAfter}
            </span>
            <div className="handle" style={{ left: `${pos}%` }} />
            <input
                type="range"
                min={0}
                max={100}
                value={pos}
                onChange={(e) => setPos(Number(e.target.value))}
                aria-label="Vorher-Nachher Vergleich"
                data-testid="before-after-slider"
            />
        </div>
    );
}
